import prettyDuration from 'pretty-ms';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Container, Progress, Row, Table, Input } from 'reactstrap';
import { connect, disconnect, requestDevice, shutdown, setWindSpeed } from '../../actions/sensor';
import locals from './index.scss';
export const SensorConsole = () => {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const connected = useSelector((state) => state.report.connected);
    const shuttingdown = useSelector((state) => state.report.shuttingdown);
    const latest = useSelector((state) => state.report.latest);
    const onConnect = async () => {
        if (connected) {
            await dispatch(disconnect());
        }
        else {
            await dispatch(requestDevice());
            await dispatch(connect());
        }
    };
    const onShutdown = () => dispatch(shutdown());
    //   const onSetWindSpeed = (speed: number) => dispatch(setWindSpeed(speed));
    return (React.createElement(Container, { className: locals.container },
        React.createElement(Row, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { color: connected ? 'success' : 'primary', onClick: onConnect }, connected ? '断开连接' : '连接设备'),
                React.createElement(Button, { disabled: !connected, color: connected ? 'danger' : undefined, onClick: onShutdown }, shuttingdown ? '关机中' : '关机'))),
        React.createElement(Row, null,
            React.createElement("h3", null, "MOPS \u5FFB\u98CE\u968F\u8EAB\u7A7A\u6C14\u51C0\u5316\u5668"),
            React.createElement(Table, { responsive: true },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u7535\u6C60")),
                        React.createElement("td", null,
                            React.createElement(Progress, { value: (_a = latest.batteryCapacity) !== null && _a !== void 0 ? _a : 0 },
                                latest.batteryCapacity ? `${latest.batteryCapacity}%` : 'N/A',
                                " ",
                                latest.batteryCharging ? '(Charging)' : '(Discharge)'))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u8C03\u8282\u98CE\u91CF")),
                        React.createElement("td", null,
                            React.createElement(Input, { type: 'range', min: 0, max: 100, step: 1, value: (_b = latest.windSpeed) !== null && _b !== void 0 ? _b : 0, id: 'windSpeed', onChange: (event) => dispatch(setWindSpeed(parseInt(event.target.value))) }))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u5F53\u524D\u98CE\u91CF")),
                        React.createElement("td", { className: 'text-monospace' }, latest.windSpeed ? latest.windSpeed + '%' : 'N/A')),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u8FD0\u884C\u65F6\u95F4")),
                        React.createElement("td", { className: 'text-monospace' }, latest.runTime ? prettyDuration(latest.runTime * 1000) : 'N/A')),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u542F\u52A8\u65F6\u95F4")),
                        React.createElement("td", { className: 'text-monospace' }, latest.bootTime ? prettyDuration(latest.bootTime * 1000) : 'N/A')),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("strong", null, "\u56FA\u4EF6\u7248\u672C")),
                        React.createElement("td", { className: 'text-monospace' }, (_c = latest.version) !== null && _c !== void 0 ? _c : 'N/A'))))),
        React.createElement(Row, null,
            React.createElement("p", null, "\u5728\u9879\u76EE`MOPS\u00B7VIDA PM Watchdog`\u7684\u57FA\u7840\u4E0A\u589E\u52A0\u98CE\u91CF\u8C03\u8282\u529F\u80FD \u539F\u9879\u76EE\u5730\u5740\u662F https://github.com/NiceLabs/mops-vida-pm-watchdog"),
            React.createElement("p", null, "\u672C\u9879\u76EE\u5730\u5740\u662F https://github.com/createskyblue/mops_xinfeng"))));
};
const RecordDate = ({ value }) => {
    if (value === undefined) {
        return React.createElement("span", null, "N/A");
    }
    return (React.createElement("span", null,
        value.toLocaleString(),
        " (Delay: ",
        prettyDuration(Date.now() - value.getTime()),
        ")"));
};
